import { render } from "./HeaderLayout.vue?vue&type=template&id=48646d2a"
import script from "./HeaderLayout.vue?vue&type=script&lang=js"
export * from "./HeaderLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/student/HeaderLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48646d2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48646d2a', __exports__)) {
    api.reload('48646d2a', __exports__)
  }
  
  module.hot.accept("./HeaderLayout.vue?vue&type=template&id=48646d2a", () => {
    api.rerender('48646d2a', render)
  })

}


export default __exports__